'use client';

import { useId, useLayoutEffect, useSyncExternalStore } from 'react';

const layers: Array<{ id: string; kind: 'host' | 'sdk'; base: number }> = [];
const listeners = new Set<() => void>();
let revision = 0;
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const snapshot = () => revision;

/** 只在 SDK 与宿主叠加时调整现有层级，焦点和滚动仍交给同一个 MUI ModalManager。 */
export function useModalLayer(open: boolean, base = 1300, kind: 'host' | 'sdk' = 'host') {
  const id = useId();
  useSyncExternalStore(subscribe, snapshot, () => 0);
  useLayoutEffect(() => {
    if (!open) return;
    const entry = { id, kind, base };
    layers.push(entry);
    publish();
    return () => {
      layers.splice(layers.indexOf(entry), 1);
      publish();
    };
  }, [id, open, base, kind]);
  const index = layers.findIndex((entry) => entry.id === id);
  return index >= 0 && layers.some((entry) => entry.kind === 'sdk')
    ? Math.max(1300, ...layers.map((entry) => entry.base)) + index
    : undefined;
}

function publish() {
  revision++;
  listeners.forEach((listener) => listener());
}
